import React, { useContext, useEffect, useState } from "react"

import { Box } from "@rebass/grid/emotion"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { useIsFirstRender } from "../../../../../hooks/useIsFirstRender"
import { ModalWild } from "@nutrafol/nutrafol-ui-kit/dist/ModalWild"
import ModalNova from "@nutrafol/nutrafol-ui-kit/dist/ModalNova"

import Image from "../../../../image"
import MenOptionsTest from "./menoptionstest"
import FaqArea from "./faq"
import FaqAlt from "./faqalt"
import ImageArea from "./imagearea"
import Dermbadge from "./dermbadge"

import ModalWildImage from "../../../master/modalwildimage"
import UserContext from "../../../../../context/UserContext"
import GwpAtcAreabanner from "../../gwp/gwpatcareabanner"
import GWpAtcModalContent from "../../gwp/gwpatcmodalcontent"

import {
  ATCFullWrap,
  ATCWrap,
  TitleAndInfo,
  ImageWrap,
  Title,
  IconsWrap,
  Icon,
  ModalContent,
} from "./menatc.styled"
// some upsell ab test magic
import { UPSELL_PROPS_VARIANT } from "./abtest/coreproduct-upsell-variant"
import CoreUpsellVariant from "./abtest/coreproduct-upsell-variant"

const MenATC = ({ data, isAltFaq = false }) => {
  const {
    containerOverrideClass,
    showSupplementLabel = true,
    savingstag,
    title,
    subtitle,
    NavIcon,
    mainimg,
    mainimgAlt,
    supplement_label,
    supplement_label2 = false,
    icons,
    questions,
    imageArea,
    options,
    gwpData = null,
  } = data

  const copy2 = `Choose an option:`
  const copy3 = `View Supplement Label`
  const copy4 =
    questions && questions[questions.length - 1].answer[1]?.label
      ? questions[questions.length - 1].answer[1]?.label
      : copy3
  const [modalVisible, toggleModalVisible] = useState(false)
  const [modalVisible2, toggleModalVisible2] = useState(false)
  const [upsellVisible, setUpsellVisible] = useState(false)
  const [upsellOption, setUpsellOption] = useState(null)
  const [gwpModalVisible, setGwpModalVisible] = useState(false)
  const upsellProps = UPSELL_PROPS_VARIANT
  const isFirstRender = useIsFirstRender()

  ////////////////// HANDLE ATC DATA START
  const userState = useContext(UserContext)
  useEffect(() => {
    userState.setAtcData(data)
    userState.setActiveOption(0)
    if (!savingstag) {
      segmentEvent("Product Viewed", {
        image_url: mainimg,
        name: options[0].name_magento || title,
      })
    }

    return () => {
      userState.setAtcData(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  ////////////////// HANDLE ATC DATA END

  useEffect(() => {
    if (isFirstRender) {
      return
    }
    if (upsellVisible) {
      segmentEvent("Upsell Product Shown", {
        products: [
          {
            billing_interval: upsellProps?.UPSELL_COMBO_PROPS?.billing_interval,
            image_url: upsellProps?.UPSELL_COMBO_PROPS?.image.url,
            name: upsellProps?.UPSELL_COMBO_PROPS?.name,
            price: upsellProps?.UPSELL_COMBO_PROPS?.price,
            product_category: upsellProps?.UPSELL_COMBO_PROPS?.product_category,
            product_gender: upsellProps?.UPSELL_COMBO_PROPS?.product_gender,
            purchase_type: upsellProps?.UPSELL_COMBO_PROPS?.purchase_type,
            shipping_interval:
              upsellProps?.UPSELL_COMBO_PROPS?.shipping_interval,
            sku: upsellProps?.UPSELL_COMBO_PROPS?.sku,
            subscription_type:
              upsellProps?.UPSELL_COMBO_PROPS?.subscription_type,
          },
        ],
        source: upsellProps.UPSELL_SOURCE,
      })
    } else {
      segmentEvent("Modal Closed", {
        image_url: upsellProps?.UPSELL_COMBO_PROPS?.image.url,
        name: upsellProps?.UPSELL_NAME,
      })
    }
  }, [upsellVisible])

  useEffect(() => {
    if (!!window.attentive_overlay) {
      try {
        window.attentive_overlay.style.zIndex = upsellVisible
          ? "10"
          : "2147483647"
      } catch (error) {
        console.error("attentive_overlay  zIndex failed ", error)
      }
    }
  }, [upsellVisible])

  //NT2-21152 AB Test Removal | Men's 1oz HS PDP Upsell
  const upsellCallback = (resJson = []) => {
    if (resJson[0]?.cart_id) {
      setUpsellOption(
        userState.atcData.options.find((el) => el.sku.includes("1-S01"))
      )
      setUpsellVisible(true)
    } else {
      console.error("cart_id missing")
    }
  }

  const showModal = () => {
    toggleModalVisible(true)
    segmentEvent("Modal Viewed", {
      name: copy3,
    })
  }

  const showModal2 = () => {
    toggleModalVisible2(true)
    segmentEvent("Modal Viewed", {
      name: copy4,
    })
  }

  const handleGwpModal = () => {
    segmentEvent("Modal Viewed", {
      name: gwpData.modal.title,
    })
    setGwpModalVisible(true)
  }

  const wmap = [0.34, 0.36, 0.3]

  const renderIcons =
    icons && icons.map
      ? icons.map((el, idx) => {
          return (
            <Icon
              key={`i${idx}`}
              className={`i${idx}`}
              width={[1, 1, wmap[idx]]}
              pb={[24, 24, 0]}
              pr={[0, 0, 0]}
            >
              <Box width={[0.2, 0.2, 0.3]}>
                <img src={el.icon} alt={``} role={`presentation`} />
              </Box>
              <Box width={[0.8, 0.8, 0.7]}>
                <TextElementMen
                  element="p"
                  text={el.text}
                  className="body--small el-text text-master-secondary-default"
                />
              </Box>
            </Icon>
          )
        })
      : null

  return (
    <ATCFullWrap className={containerOverrideClass || ""}>
      <ATCWrap className="row cf">
        <ImageWrap width={[1, null, 1 / 2]} className={``} order={[1, 1, 0]}>
          <div className={`show-md-up`}>
            <Image
              filename={mainimg}
              classes="product-image main-pdp-image"
              alt={mainimgAlt ? mainimgAlt : title}
            />
            <Dermbadge />
          </div>
          <ImageArea data={imageArea} />
        </ImageWrap>
        <TitleAndInfo
          width={[1, null, 1 / 2]}
          order={[0, 0, 1]}
          pt={[0, 0, 0, 0, 40]}
        >
          <div className="sticky">
            {gwpData ? (
              <GwpAtcAreabanner
                data={gwpData}
                handleGwpModal={handleGwpModal}
              />
            ) : null}
            <Title className={`pb-8 sm:pb-4 md:pb-8`}>
              {NavIcon ? (
                <Box
                  width={[0.15, 0.15, 0.1]}
                  pr={16}
                  className={`NavIconWrap`}
                >
                  <img src={NavIcon} alt={``} />
                </Box>
              ) : null}
              <Box width={["auto", "auto", 0.9]}>
                <TextElementMen
                  element="h1"
                  text={title}
                  className="title--large-i title text-men-secondary-secondary gotham"
                />
              </Box>
            </Title>
            <div className={`hide-md-up`}>
              <Image
                filename={mainimg}
                classes="product-image main-pdp-image"
                alt={mainimgAlt ? mainimgAlt : title}
              />
              <Dermbadge />
            </div>
            <div className={`show-md-up`}>
              <TextElementMen
                element="p"
                text={subtitle}
                className="body--regular text-men-secondary-secondary "
              />
              {isAltFaq ? (
                <Box mt={[24]}>
                  <FaqAlt questions={questions} />
                </Box>
              ) : null}
              {supplement_label2 === false && showSupplementLabel ? (
                <TextElementMen
                  element="button"
                  onClick={showModal}
                  onKeyPress={showModal}
                  text={copy3}
                  className="body--small uppercase supplink text-men-primary-default"
                />
              ) : null}
              {isAltFaq && icons ? (
                <IconsWrap pt={[32, 40, 64]}>{renderIcons}</IconsWrap>
              ) : null}
            </div>
            <Box mt={[0, null, 40, 64]}>
              <TextElementMen
                element="p"
                text={<span id="atc-label">{copy2}</span>}
                className="body--large-b font-bold text-men-secondary-default mb-1"
              />
            </Box>
            {gwpData ? (
              <MenOptionsTest
                state={userState}
                savingstag={savingstag}
                upsellCallback={upsellCallback}
                atcCard={gwpData.atcCard}
                handleGwpModal={handleGwpModal}
              />
            ) : (
              <MenOptionsTest
                state={userState}
                savingstag={savingstag}
                upsellCallback={upsellCallback}
              />
            )}
            <div className={`hide-md-up `}>
              <TextElementMen
                element="p"
                text={subtitle}
                className="body--regular text-men-secondary-secondary mt-8"
              />
              {isAltFaq ? (
                <Box mt={[24]} mb={[24]}>
                  <FaqAlt questions={questions} />
                </Box>
              ) : null}
              {supplement_label2 === false && (
                <TextElementMen
                  element="button"
                  onClick={showModal}
                  onKeyPress={showModal}
                  text={copy3}
                  className="body--regular uppercase supplink text-men-primary-default supplinkmob"
                />
              )}
              {isAltFaq && icons ? (
                <IconsWrap pt={[32]}>{renderIcons}</IconsWrap>
              ) : null}
            </div>
            {isAltFaq ? null : (
              <>
                {icons ? (
                  <>
                    <IconsWrap pt={[32, 40, 64]} pb={[8, 8, 64]}>
                      {renderIcons}
                    </IconsWrap>
                    <FaqArea
                      questions={questions}
                      showModal={showModal}
                      showModal2={showModal2}
                    />
                  </>
                ) : (
                  <>
                    <Box mt={"-1px"}>
                      <FaqArea
                        questions={questions}
                        showModal={showModal}
                        showModal2={showModal2}
                      />
                    </Box>
                  </>
                )}
              </>
            )}
          </div>
        </TitleAndInfo>
      </ATCWrap>
      <div className={`supplinkwrap`}>
        {modalVisible && (
          <ModalWildImage
            component={ModalContent}
            propsObject={{
              image: supplement_label,
            }}
            hideModal={() => toggleModalVisible(false)}
            modalSize="small"
          />
        )}
        {modalVisible2 && (
          <ModalWildImage
            component={ModalContent}
            propsObject={{
              image: supplement_label2,
            }}
            hideModal={() => toggleModalVisible2(false)}
            modalSize={`small ${copy4.toLowerCase()}`}
          />
        )}
      </div>
      <div className={`upsellwrap`}>
        {upsellVisible && (
          <ModalWild
            component={CoreUpsellVariant}
            hideModal={() => setUpsellVisible(false)}
            propsObject={{ upsellOption }}
            modalSize="small"
            customZIndex={99999} // to be on top of the ada chat bot
          />
        )}
      </div>
      <div>
        {gwpModalVisible ? (
          <div className={`gwpwrap`}>
            <ModalNova
              hideModal={() => setGwpModalVisible(false)}
              modalSize="small"
              title={gwpData.modal.title}
            >
              <GWpAtcModalContent data={gwpData.modal} />
            </ModalNova>
          </div>
        ) : null}
      </div>
    </ATCFullWrap>
  )
}

export default MenATC
